import axios, { clientContext } from './config'

const apiStyleGames = {
  getUpcomingStylesToRate (offset = 0) {
    return axios.get(`/api/clients/${clientContext.getUsername()}/new_style_colors/`, { params: { offset } })
  },
  getBeTheBuyerStyles () {
    return axios.get('/api/prebuystylecolors/?type=daily_game')
  },
  getBeTheBuyerDailySummary () {
    return axios.get('/api/prebuystylecolors/daily_summary/')
  },
  rateBeTheBuyerStyleColor (data) {
    return axios.post('/api/prebuystylecolorratings/', data)
  }
}

export default apiStyleGames
